if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      show(opener) {
        this.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach((media) => {
          media.hidden = media.dataset.mediaId !== opener.dataset.mediaId;
        });
        super.show(opener);
        const activeMedia = this.querySelector(`[data-media-id="${opener.dataset.mediaId}"]`);
        activeMedia?.scrollIntoView({ block: 'center' });
      }
    }
  );
}
